import { TextAlign, TextAnchor } from '@/types';

// @ts-ignore left is equal to the default value
const mapping: Record<TextAlign, TextAnchor> = {
  center: 'middle',
  right: 'end',
};

export const textAlignToAnchor = (align: TextAlign): TextAnchor => {
  return mapping[align] || 'start';
};
